import { useContext, useEffect, useState } from "react";
import CalendarIcon from "../../Assets/Icons/outline/calendar.svg";
import UserAddIcon from "../../Assets/Icons/outline/user-add.svg";
import CalendarPicker from "../../Components/CalendarPicker/CalendarPicker";
import Input from "../../Components/Input";
import moment from "moment";
import AdminContext from "../../Services/Admin";
import ContributorPicker from "../../Components/ContributorPicker/ContributorPicker";
import { toast } from "react-toastify";
import Select from "../../Components/Select";
import { isSupervisorAndSuperAdmin } from "../../utils/auth";

const TaskModal = ({
	dataContributor,
	setDataContributor,
	register,
	errors,
	control,
	watch,
	dataProject,
	dataTask,
	setValue,
	reset,
}) => {
	const { getAllMaster } = useContext(AdminContext);
	const [datePicker, setDatePicker] = useState({ start: null, end: null });
	const [showCalendar, setShowCalendar] = useState(false);
	const [showContributor, setShowContributor] = useState(false);
	const [dataGroup, setDataGroup] = useState([]);
	const [contributorPicker, setContributorPicker] = useState([]);
	const [groupId, setGroupId] = useState(null);

	const getDataGroup = async () => {
		const newData = await getAllMaster(`master/group`);
		if (newData) {
			setDataGroup(newData?.data?.map((item) => ({ value: item?.id, label: item?.name })));
		}
	};

	useEffect(() => {
		const subscription = watch((value, { name }) => {
			if (name === "m_groups_id") {
				setGroupId(value?.m_groups_id);
			}
		});
		return () => subscription.unsubscribe();
	}, [watch]);

	useEffect(() => {
		getDataGroup();
	}, []);

	useEffect(() => {
		if (!showContributor) {
			setDataContributor(contributorPicker);
		}
	}, [showContributor]);

	useEffect(() => {
		if (dataTask) {
			const oldData = dataTask;
			let bodyRequest = {};
			bodyRequest = {
				name: oldData?.name,
				description: oldData?.description,
				m_groups_id: oldData?.m_groups_id,
			};
			reset(bodyRequest);
			setDatePicker({ start: oldData?.start, end: oldData?.end });
			setContributorPicker(oldData?.contributor?.map((item) => item.user));
			setDataContributor(oldData?.contributor?.map((item) => item.user));
			setGroupId(oldData?.m_groups_id);
		}
	}, [dataTask]);

	useEffect(() => {
		setValue(
			"deadline",
			datePicker?.start
				? datePicker?.end
					? moment(datePicker?.start)?.format("DD/MM/YYYY") + " - " + moment(datePicker?.end)?.format("DD/MM/YYYY")
					: moment(datePicker?.start)?.format("DD/MM/YYYY") + " - " + moment(datePicker?.start)?.format("DD/MM/YYYY")
				: ""
		);
	}, [datePicker]);

	return (
		<>
			<div className="mb-5">
				<label htmlFor="name" className="block mb-3">
					Task Name <span className="text-red-500">*</span>
				</label>
				<Input
					id="name"
					placeholder="Input Task Name"
					required
					type="text"
					{...register("name")}
					errors={errors?.name?.message}
				/>
			</div>

			<div className="mb-5">
				<label htmlFor="description" className="block mb-3">
					Task Description
				</label>
				<textarea
					id="description"
					className={`border border-black text-gray-900 rounded-xl focus:ring-black focus:border-black block w-full p-3`}
					placeholder="Input Task Description"
					required
					{...register("description")}
				/>
				{errors?.description?.message && <small className={`text-[red]`}>{errors?.description?.message}</small>}
			</div>

			<div className="mb-5">
				<label htmlFor="m_groups_id" className="block mb-3">
					Group <span className="text-red-500">*</span>
				</label>
				<Select control={control} id="m_groups_id" data={dataGroup} />
			</div>

			<div className="mb-5 relative">
				<label htmlFor="contributor" className="block mb-3">
					PIC <span className="text-red-500">*</span>
				</label>
				<div className="flex items-center">
					<div className="w-full">
						<Input
							id="contributor"
							placeholder="Select PIC"
							required
							readOnly
							type="text"
							value={dataContributor
								?.map((item) => item?.name)
								.join(", ")
								?.toString()}
						/>
					</div>
					<div
						className="w-[60px] ms-3 mb-3"
						role="button"
						onClick={() => (groupId ? setShowContributor(true) : toast.error("Select group first!"))}
					>
						<img src={UserAddIcon} className="w-[40px] h-[40px]" alt="" />
					</div>
				</div>
				{showContributor && (
					<ContributorPicker
						contributorPicker={contributorPicker}
						setContributorPicker={setContributorPicker}
						setShowContributor={setShowContributor}
						groupId={groupId}
					/>
				)}
			</div>

			<div className="mb-5 relative">
				<label htmlFor="deadline" className="block mb-3">
					Deadline <span className="text-red-500">*</span>
				</label>
				<div className="flex items-center">
					<div className="w-full">
						<Input id="deadline" placeholder="Input Deadline" required type="text" {...register("deadline")} />
					</div>
					<div className="w-[60px] ms-3 mb-3" role="button" onClick={() => setShowCalendar(true)}>
						<img src={CalendarIcon} className="w-[40px] h-[40px]" alt="" />
					</div>
				</div>
				{showCalendar && (
					<CalendarPicker
						datePicker={datePicker}
						setDatePicker={setDatePicker}
						setShowCalendar={setShowCalendar}
						minDate={dataProject?.start}
						maxDate={dataProject?.end}
					/>
				)}
			</div>
		</>
	);
};

export default TaskModal;
